import { HorizontalStepper } from "@dune/ui";
import { useQueryState } from "nuqs";
import { ReceptionStep1 } from "./steps/ReceptionStep1";
import { ReceptionStep2Documents } from "./steps/ReceptionStep2Documents";
import { ReceptionStep3Participants } from "./steps/ReceptionStep3Participants";
import { ReferenceableFilesCountBanner } from "../../../component/constructionSites/ReferenceableFilesCountBanner";
import { useRequiredParams } from "../../../hooks/useRequiredParams";

const STEP_RECEPTION_INFO = 1;
const STEP_DOCUMENTS = 2;
const STEP_PARTICIPANTS = 3;

const RECEPTION_STEPS = [
	{ step: STEP_RECEPTION_INFO, title: "Réception" },
	{ step: STEP_DOCUMENTS, title: "Dépôt de documents" },
	{ step: STEP_PARTICIPANTS, title: "Intervenants" },
];

export const ProjectReceptionContent = () => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();
	const [currentStepIndex, setCurrentStepIndex] = useQueryState("step", {
		defaultValue: STEP_RECEPTION_INFO,
		parse: (value) => {
			const parsed = Number(value);
			if (Number.isNaN(parsed) || parsed < 1 || parsed > 4) {
				return STEP_RECEPTION_INFO;
			}
			return parsed;
		},
		serialize: (value) => String(value),
	});

	return (
		<div className="flex flex-col gap-4">
			<HorizontalStepper
				steps={RECEPTION_STEPS}
				currentStepIndex={currentStepIndex}
				setCurrentStepIndex={setCurrentStepIndex}
				parentPaddingOffsetPx={24}
			/>
			<ReferenceableFilesCountBanner
				constructionSiteId={Number(constructionSiteId)}
			/>
			{currentStepIndex === STEP_RECEPTION_INFO && (
				<ReceptionStep1 onNext={() => setCurrentStepIndex(STEP_DOCUMENTS)} />
			)}
			{currentStepIndex === STEP_DOCUMENTS && (
				<ReceptionStep2Documents
					onPrev={() => setCurrentStepIndex(STEP_RECEPTION_INFO)}
					onNext={() => setCurrentStepIndex(STEP_PARTICIPANTS)}
				/>
			)}
			{currentStepIndex === STEP_PARTICIPANTS && (
				<ReceptionStep3Participants
					onPrev={() => setCurrentStepIndex(STEP_DOCUMENTS)}
				/>
			)}
		</div>
	);
};

export default ProjectReceptionContent;
